﻿import React, { Fragment, useState, useEffect } from 'react';
import { MenuItem } from "@blueprintjs/core";
import { MultiSelect } from "@blueprintjs/select";
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FormHelperText } from "components/form-fields";
import 'components/form-fields/FormFields.css';
import { ShowHide } from 'components/layout';

const defaultArray = [];

export function FormMultiSelect(
    {
        id = null,
        placeholder = "Choose an item",
        items = defaultArray,
        loading = false,
        headingText = "",
        helperText = null,
        disabled = false,
        selectedValues = null,
        dangerHelperText = null,
        resetOnSelect = true,
        largeList = false,
        fill = false,
        wide = false,
        onItemSelect,
        onRemove
    }
) {

	const [selectedItems, setSelectedItems] = useState([]);
	const minFilterLength = 3;
	useEffect(setItemsFromValues, [selectedValues, items]);

	function setItemsFromValues() {
		var itemsValue = [];
		if (selectedValues && items && selectedValues.length > 0 && items.length > 0) {
			//Try and find the item in the list
			selectedValues.forEach(function (v) {
				const item = getItemFromValue(v.id);

				if (item) {
					itemsValue.push(item);
				}
			});
		}
		setSelectedItems(itemsValue);
	}

	function filteritems(query, item) {
		if (largeList && query.length < minFilterLength ) {
			return false;
        }
		return item.name.toLowerCase().indexOf(query.toLowerCase()) >= 0;
	}

	function getItemFromValue(idValue) {
		return items.find(obj => obj.id === idValue);
	}

	function isSelected(item) {		
		return selectedValues.some(function (x) {
			return x.id === item.id
		});
	}

	function renderSelect(item, { handleClick, modifiers }) {
		const hasDescription = typeof item.description === "string" && item.description.length > 0;
		let itemText = item.name;

		if (hasDescription) {
			itemText = (
				<Fragment>
					<div>{item.name}</div>
					<div className="form-multi-select-option-description">{item.description}</div>
				</Fragment>
			);
		}

		return (
			<MenuItem
				icon={isSelected(item) ? "tick" : "blank"}
				onClick={handleClick}
				key={item.id}
				text={itemText}
				multiline={hasDescription}
				disabled={modifiers.disabled}
				shouldDismissPopover={false}
			/>
		);
	}

	function tagRender(item) {
		return item.name;
    }

	return (
        <div className="form-field form-field-multi-select" id={id}>
            <ShowHide
				evaluator={headingText.length > 0}
				show={(
					<h4 className={classNames({ "bp6-skeleton": loading })}>{headingText}</h4>
				)}
			>
			</ShowHide>
            <FormHelperText loading={loading}>{helperText}</FormHelperText>
            <MultiSelect
				className={classNames({ "bp6-skeleton": loading, "fill": fill, "wide-select": wide })}
				items={items}
				onItemSelect={onItemSelect}
				itemRenderer={renderSelect}
				tagRenderer={tagRender}
				filterable={false}
				popoverProps={{ minimal: true, placement: "bottom-start", boundary: "window" }}
				disabled={disabled}
				selectedItems={selectedItems}
				placeholder={placeholder}
				resetOnSelect={resetOnSelect}
				itemPredicate={filteritems}
				tagInputProps={{
					onRemove: onRemove,
					disabled: disabled
				}}
			>
			</MultiSelect>
            <FormHelperText loading={loading} danger={true}>{dangerHelperText}</FormHelperText>
        </div>
    );
		
}

FormMultiSelect.propTypes = {
    id: PropTypes.string,
	placeholder: PropTypes.string,
	items: PropTypes.array,
	onItemSelect: PropTypes.func.isRequired,
	onRemove: PropTypes.func.isRequired,
	dynamicWidth: PropTypes.bool,
	loading: PropTypes.bool,
	headingText: PropTypes.string,
	helperText: PropTypes.node,
	disabled: PropTypes.bool,
	selectedValues: PropTypes.array,
	dangerHelperText: PropTypes.node,
	resetOnSelect: PropTypes.bool,
	largeList: PropTypes.bool,
	fill: PropTypes.bool,
	wide: PropTypes.bool,
};